import MapLocationDetailTileExpandedState from './MapLocationDetailTileExpandedState';

export default MapLocationDetailTileExpandedState;
